import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { WidgetProps } from '@/lib/widgets/types';
import { Plus, Car, User, Wrench, MapPin } from 'lucide-react';
import { useParams } from 'react-router-dom';
import { useAuth } from '@/hooks/use-auth';
import { VehicleFormSheet } from '@/components/fleet/VehicleFormSheet';
import { DriverFormSheet } from '@/components/fleet/DriverFormSheet';
import { TripFormSheet } from '@/components/fleet/TripFormSheet';
import { WorkOrderFormSheet } from '@/components/fleet/WorkOrderFormSheet';
// import { useVehicles } from '@/hooks/use-vehicles';
// import { useMaintenancePlans } from '@/hooks/use-maintenance-plans';
// import { useFleetProviders } from '@/hooks/use-fleet-providers';

export function FleetQuickActionsWidget({ isEditing = false }: WidgetProps) {
  const { slug: companySlug } = useParams<{ slug: string }>();
  const { user, companies } = useAuth();
  
  // Get company ID from current slug
  const companyId = companies.find(c => c.slug === companySlug)?.id || user?.user_metadata?.company_id;
  
  // Modal states
  const [vehicleModalOpen, setVehicleModalOpen] = useState(false);
  const [driverModalOpen, setDriverModalOpen] = useState(false);
  const [tripModalOpen, setTripModalOpen] = useState(false);
  const [workOrderModalOpen, setWorkOrderModalOpen] = useState(false);

  // Data for WorkOrderModal - temporarily using empty arrays
  const vehicles: any[] = [];
  const maintenancePlans: any[] = [];
  const providers: any[] = [];

  const actions = [
    { 
      label: 'Novo Veículo', 
      icon: Car, 
      action: () => setVehicleModalOpen(true),
      color: 'bg-blue-500 hover:bg-blue-600' 
    },
    { 
      label: 'Novo Motorista', 
      icon: User, 
      action: () => setDriverModalOpen(true),
      color: 'bg-green-500 hover:bg-green-600' 
    },
    { 
      label: 'Nova Viagem', 
      icon: MapPin, 
      action: () => setTripModalOpen(true),
      color: 'bg-purple-500 hover:bg-purple-600' 
    },
    { 
      label: 'Manutenção', 
      icon: Wrench, 
      action: () => setWorkOrderModalOpen(true),
      color: 'bg-orange-500 hover:bg-orange-600' 
    }
  ];

  return (
    <>
      <Card className="h-full">
        <CardHeader>
          <CardTitle className="text-sm font-medium">Ações Rápidas - Fleet</CardTitle>
        </CardHeader>
        <CardContent className="space-y-2">
          {actions.map((action, index) => (
            <Button
              key={index}
              variant="outline"
              className={`w-full justify-start gap-2 h-auto py-3 border-2 transition-all duration-200 hover:scale-[1.02] hover:shadow-md ${action.color} hover:border-transparent text-white hover:text-white`}
              onClick={action.action}
              disabled={isEditing}
            >
              <action.icon className="h-4 w-4" />
              {action.label}
            </Button>
          ))}
        </CardContent>
      </Card>

      {/* Modals */}
      <VehicleFormSheet
        open={vehicleModalOpen}
        onOpenChange={setVehicleModalOpen}
        companyId={companyId}
        onSubmit={() => {}}
      />

      <DriverFormSheet
        open={driverModalOpen}
        onOpenChange={setDriverModalOpen}
        companyId={companyId}
        mode="create"
      />

      <TripFormSheet
        open={tripModalOpen}
        onOpenChange={setTripModalOpen}
        companyId={companyId}
        mode="create"
      />

      <WorkOrderFormSheet
        open={workOrderModalOpen}
        onOpenChange={setWorkOrderModalOpen}
        onSubmit={() => setWorkOrderModalOpen(false)}
        vehicles={vehicles}
        maintenancePlans={maintenancePlans}
        providers={providers}
      />
    </>
  );
}